import { render, staticRenderFns } from "./wordcloud.vue?vue&type=template&id=11c4b05e&"
import script from "./wordcloud.vue?vue&type=script&lang=js&"
export * from "./wordcloud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports